<script setup lang="ts">
import FinanceOverview from './FinanceOverview.vue';
import OrderDiscounts from './OrderDiscounts.vue';
import OrderAddresses from './OrderAddresses';
import OrderNotes from "./OrderNotes.vue";
import OrderCustomer from "@/components/Order/OrderSidebar/OrderCustomer";
import AppSlotView from "@/AppSlotView.vue";

import {apps} from '@hantera/portal-app'
</script>

<template>
  <div class="order-sidebar neat-scroll">
    <FinanceOverview />

    <OrderDiscounts />

    <OrderNotes />
    
    <OrderAddresses />
    
    <OrderCustomer />
    
    <AppSlotView :slot="apps.orderViewSlots.sidebar" />
    
  </div>
</template>

<style>
.order-sidebar {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
</style>